<template>
  <el-cascader
    v-model="currentValue"
    :options="subjectOptions"
    :props="subjectProps"
    collapse-tags
    @change="change"
    size="small"
    clearable></el-cascader>
</template>

<script>
import { getSubjectstree } from "@/services/subject";
export default {
  name: 'subjectCascader',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    onChange: Function,
    teamCodeList: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      currentValue: [],
      subjectProps: {
        multiple: true,
        expandTrigger: "hover",
      },
      subjectOptions: []
    }
  },
  created () {
    this.getSubjectstree();
  },
  watch: {
    teamCodeList(v) {
      this.getSubjectstree();
    },
    value: {
      immediate: true,
      handler(v) {
        this.currentValue = v || [];
      }
    }
  },
  methods: {
    async getSubjectstree() {
      const res = await getSubjectstree(this.teamCodeList);
      const { data, errCode } = res.data;
      if (errCode === 0) {
        this.subjectOptions = this.getCascaderList(data);
      }
    },
    getCascaderList(data) {
      if (!Array.isArray(data)) return data;
      return data.map(d => {
        if (Array.isArray(d.children)) {
          Object.assign(d, { children: this.getCascaderList(d.children) })
        }
        return Object.assign(d, { label: d.name, value: d.name });
      })
    },
    change(value) {
      const subject_type = value.map(list => {
        const newList = [].concat(list);
        return newList.pop();
      });
      this.$emit('input', value);
      if (typeof this.onChange === 'function') {
        this.onChange(subject_type);
      }
    }
  }
}
</script>
